import { ReactNode } from 'react';
import styles from './SearchContentPreviewGrid.module.scss';

export interface SearchContentPreviewGridProps {
  heading: ReactNode;
  subHeading?: ReactNode;
  button?: ReactNode;
  children: ReactNode;
}

export function SearchContentPreviewGrid(props: SearchContentPreviewGridProps) {
  const { subHeading, heading, button, children } = props;

  return (
    <div className={styles.wrapper}>
      <div className="row">
        <div className="col-xs-12">
          <div className={styles.headingContainer}>
            <div className={styles.heading}>{heading}</div>
            {subHeading && (
              <div className={styles.subHeading}>{subHeading}</div>
            )}
          </div>
        </div>
      </div>

      {children}

      {button && (
        <div className="row">
          <div className="col-xs-12">
            <div className={styles.button}>{button}</div>
          </div>
        </div>
      )}
    </div>
  );
}
